import React from 'react';
import { useTranslation } from '../../context/TranslationContext';

export default function UITab({ languages, register, uiLanguageValue, handleLanguageChange, uiThemeValue, handleThemeChange }) {
  const { t } = useTranslation();

  return (
    <div className="wa-form-group">
      {/* Interface Language */}
      <div>
        <label htmlFor="uiLanguage" className="wa-label">
          {t('CONFIG', 'UI_LANGUAGE_SELECT', 'Interface Language')}
        </label>
        {languages.length > 0 ? (
          <select
            id="uiLanguage"
            className="wa-select"
            {...register('uiLanguage')}
            onChange={handleLanguageChange}
            value={uiLanguageValue}
          >
            {languages.map(lang => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </select>
        ) : (
          <div className="wa-select flex items-center justify-center">
            <span>{t('CONFIG', 'LOADING_LANGUAGES', 'Chargement des langues...')}</span>
          </div>
        )}
      </div>

      {/* Interface Theme */}
      <div style={{ marginTop: '1.5rem' }}>
        <label htmlFor="uiTheme" className="wa-label">
          {t('CONFIG', 'UI_THEME_SELECT', 'Thème de l\'interface')}
        </label>
        <select
          id="uiTheme"
          className="wa-select"
          {...register('uiTheme')}
          onChange={handleThemeChange}
          value={uiThemeValue}
        >
          <option value="light">{t('CONFIG', 'THEME_LIGHT', 'Clair')}</option>
          <option value="dark">{t('CONFIG', 'THEME_DARK', 'Sombre')}</option>
        </select>
      </div>
    </div>
  );
}
